module.exports = "<div id=\"search-component\">\n  <h4>{{ getUserString() }} Search</h4>\n  <input #searchBox id=\"search-box\" autocomplete=\"off\" (keyup)=\"search(searchBox.value)\" />\n  <div *ngIf=\"!hide\">\n    <div *ngFor=\"let user of users | async\" (click)=\"gotoDetail(user)\" class=\"search-result\" >\n      <label>{{user.name}}</label>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/search/user-search.component.html
// module id = 215
// module chunks = 1